<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  @import "./ol.css";

  $searchbox_height: 4.85em; // = 64px (body font size =?)
  $searchbox_height_16px: 4em; // = 64px (body font size =16px)
  $button_size_14px: 3em; // = 42px (body font size = 14px)
  $button_size_20px: 2.1em; // = 42px (body font size = 20px)


  .screencontainer2 {
    width: 100%;
    height: 100%;
    border: black 2px solid;
  }

  .searchBox{
    // .v-input font-size: 16px; (= body font size)
    padding-left: 17px;
    padding-right: 17px;
    height: $searchbox_height_16px; // = 64px
    top: 15px;
  }

  .ol-control:hover{
      background-color: rgba(0, 0, 0, 0);
    }

  .ol-control {
    font-size: 18px;

    button {
      background-color: rgba(245, 245, 245, 1);
      color: black;
      font-weight: normal;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
                  0px 2px 2px 0px rgba(0, 0, 0, 0.14),
                  0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      transition-property: box-shadow, transform, opacity, -webkit-box-shadow, -webkit-transform;
      border-radius: 4px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    button:hover {
      background-color: rgba(245, 245, 245, 1);
      color: black;
    }

    button:focus {
      background-color: rgba(245, 245, 245, 1);
      color: black;
    }
  }

  .ol-zoom {
    top: $button_size_20px/2; // = 1.05em = 21px
    left: unset !important;
    right: 0.5em;
    background-color: rgba(255, 255, 255, 0);


    .ol-zoom-in {
      height: 42px;
      width: 42px;
      min-width:42px;
      color: rgba(0, 0, 0, 0.87);
      border-radius: 4px;
    }

    .ol-zoom-out {
      height: 42px;
      width: 42px;
      min-width:42px;
      color: rgba(0, 0, 0, 0.87);
      border-radius: 4px;
    }
  }

  /*
  .layer-switcher-popup {
    z-index: 10;
    top: 1*$searchbox_height+4*$button_size;
    button {
      width: 0; //$button_size;
      height: 0;  //$button_size;
      font-size: $button_size -($button_size/8); // = 1.4em
      background-position-x: center;
      background-position-y: center;
    }
    ul {
      line-height: 2;
    }
    li.layer input {
      vertical-align: unset; //alignement checkbox avec texte
    }
    input[type=checkbox] {
      transform: scale(1.5);
    }
  }
  */

  .layer-switcher-dialog {
    // min-height: 350px;
    max-width: 220px;
  }

  .mapdiv {
    width: 100%;
    height: 85vh;
    min-height: 450px;

  }

  .layers_button {
    // .v-btn.v-size--default font-size: 0.875rem = 14px (= body font size)
    margin-right: -0.3em; // -4px
    top: $searchbox_height + (3*$button_size_14px) + 0.2; // 197px
  }

  ul {
   list-style: none;
  }
  li {
    padding-top: 0.5em;
    padding-left: 0.1em;
    text-indent: -1.5em;

  }
  label{
    padding-left: 5px;
    vertical-align: bottom;
  }

  .gps_button {
    // .v-btn.v-size--default font-size: 0.875rem = 14px (= body font size)
    margin-right: -0.3em; // -4px
    top: $searchbox_height + (4.5*$button_size_14px) + 0.2; // 260px
  }

  @media only screen and (min-width: 601px) {
    .ol-attribution {
      bottom: 1em;
      margin-right: 0.15em; // 3px
      font-size: 0.8em;
      position: fixed;
      background-color: rgba(255, 255, 255, 0);
    }
  }
  @media only screen and (max-height: 441px) {
    .ol-attribution {
      display: none;
    }
  }

  .tooltip {
    position: relative;
    padding: 3px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    opacity: 0.8;
    white-space: nowrap;
    font: 12pt sans-serif;
  }

</style>

<template>
  <v-card class="ma-0 pa-0 container--fluid" height="100%" width="100%">

    <template v-if="showSearchBox">
    <v-autocomplete
      class="searchBox"
      color="indigo lighten-1"
      chips
      dense
      append-icon="search"
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      :filter="customSearchFilter"
      :clearable="clearable"
      hide-no-data
      item-text="label"
      item-value="id"
      :label=autoCompleteMsg
      return-object
      @change="gotoSelectedAdr"
      @click:clear="clearItems"
      aria-label="recherche adresse"
    ></v-autocomplete>
    </template>

    <template v-if="gpsBlockedByUser">
    <v-snackbar
      :value="noGpsErrorMessage"
      color="error"
      top
      :multi-line="true"
      :timeout="10000"
    >
      ERREUR  : Vous avez refusé de partager votre position GPS, le tracking ne fonctionnera pas !
      <v-btn
          icon
          @click="noGpsErrorMessage = false"
        >
          <v-icon>{{mdiClose}}</v-icon>
        </v-btn>
    </v-snackbar>
    </template>

    <!-- TEST RENDU LAYERSWITCHER PERSONALISE -->
    <div class="text-xs-center">
      <v-dialog v-model="layerSwitcherVisible" width="300" eager>
        <v-card>
          <v-card-title class="subtitle-1 grey lighten-2 pl-6 pt-2 pb-1" primary-title>
            Choix des couches
          </v-card-title>

          <v-card-text>
            <div ref="divLayerSwitcherContent" id="divLayerSwitcher" class="layer-switcher-dialog" >
              <!--
              liste des couches de la carte
              <ul>
                <li class="layer"><input type="checkbox" id="61796301-585e-42ff-9cdc-df8029c843d8">
                  <label for="61796301-585e-42ff-9cdc-df8029c843d8">Limites communales</label></li>
                <li class="layer"><input type="checkbox" id="b11b5c35-406d-4860-86c8-464c616d76b8">
                  <label for="b11b5c35-406d-4860-86c8-464c616d76b8">Limites des
                    constructions</label></li>
                <li class="layer"><input type="radio" name="base"
                                         id="de0a785e-56ec-4252-bbd0-e8d196550e42"><label
                  for="de0a785e-56ec-4252-bbd0-e8d196550e42">Orthophoto 2016</label></li>
                <li class="layer"><input type="radio" name="base"
                                         id="f53ad9f1-1a8a-4e38-9bc9-899635294e53"><label
                  for="f53ad9f1-1a8a-4e38-9bc9-899635294e53">Plan cadastral</label></li>
                <li class="layer"><input type="radio" name="base"
                                         id="1afb57dd-ac06-4da9-b374-7baf4ad62dc1"><label
                  for="1afb57dd-ac06-4da9-b374-7baf4ad62dc1">Plan ville couleur</label></li>
              </ul>
              -->
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-1">
            <v-spacer></v-spacer>
            <v-btn
              color="indigo lighten-1"
              height="25"
              class="caption white--text"

              @click="layerSwitcherVisible = false"
            >
             Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div ref="mymap" class="mapdiv">
      <div ref="tooltip" class="tooltip"></div>
    </div>

    <v-btn
      class="layers_button"
      height="42"
      width="42"
      min-width="42"
      right
      absolute
      @click.stop="toggleLayerSwitcher"
      aria-label="selection couches"
    >
      <v-icon size="28">{{ mdiLayersOutline }}</v-icon>
    </v-btn>

    <template v-if="!gpsBlockedByUser">
      <v-btn
        class="gps_button"
        height="42"
        width="42"
        min-width="42"
        right
        absolute
        @click.stop="toggleGpsTracking"
        aria-label="activer geolocalisation"
      >
        <template v-if="gpsTrackingEnabled">
          <v-icon dark>gps_fixed</v-icon>
        </template>
        <template v-else>
          <v-icon>gps_off</v-icon>
        </template>
      </v-btn>
    </template>

    <v-bottom-sheet inset :hide-overlay="true" v-model="displayInfo" max-width="80%">
      <template v-slot:activator>
      </template>
      <v-toolbar color="indigo lighten-1" dark dense flat height="30">
        <v-toolbar-title class="body-1 font-weight-medium">Informations trouvées</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="displayInfo=false">
          <v-icon>highlight_off</v-icon>
        </v-btn>
      </v-toolbar>

      <v-list>
        <v-list-item-title
          v-for="item in infoList"
          :key="item.title"
          @click="displayInfo = false"
        >
          <template v-if="item.url.length >0">
            <v-list-item-title class="body-2 py-1 pl-2">
              <a :href="item.url" target="_blank"> {{ item.title | convertEntitiesInText }}</a>
            </v-list-item-title>
          </template>
          <template v-else>
            <v-list-item-title dense class="body-2 py-1 pl-2">
              {{ item.title | convertEntitiesInText }}
            </v-list-item-title>
          </template>
        </v-list-item-title>
      </v-list>
    </v-bottom-sheet>
  </v-card>
</template>

<script>
import { mdiLayersOutline, mdiClose } from '@mdi/js';
import { isNullOrUndefined, functionExist, getEl } from 'cgil-html-utils/src/cgHtmlUtils';
import axios from 'axios';
import Geolocation from 'ol/Geolocation';
import OlFeature from 'ol/Feature';
import OlFormatGeoJSON from 'ol/format/GeoJSON';
import OlPoint from 'ol/geom/Point';
import OlCircleGeom from 'ol/geom/Circle';
import OlLayerVector from 'ol/layer/Vector';
import OlSourceVector from 'ol/source/Vector';
import { Icon, Style } from 'ol/style';
import OlFill from 'ol/style/Fill';
import OlCircle from 'ol/style/Circle';
import OlStroke from 'ol/style/Stroke';
import OlStyle from 'ol/style/Style';
import OlStyleIcon from 'ol/style/Icon';
import OlOverlay from 'ol/Overlay';
import LayerSwitcher from 'ol-layerswitcher';
import { getLog, DEFAULT_BASE_SERVER_URL } from '../config';
import {
  createLausanneMap, // Conv4326In2056,
  getLayerByName, getNumberFeaturesInLayer,
  getVectorSourceGeoJson, getBBFromFeature,
  getPolygonStyle, // isItMN03, Conv21781In2056, // Conv2056In21781,
} from './ol-lausanne-map-mn95-4sentinelle';
import externalPolygon from './geodata/exteriorPolygon';
import sectors from './geodata/secteurs';
import { getLocalJwtTokenAuth } from './Login';

const geoJsonLayerName = 'gobjects_points_of_interest';
const geoJsonMarkersLayerName = 'gobjects_new_markers';
const coordPfa3180Stfrancois = [538224.21, 152378.17]; // PFA3 180 - St-Francois
// const TopBarHeight = 69;
const MODULE_NAME = 'cgil-map';
const log = getLog(MODULE_NAME, 5, 2);
const EXTENT = [534500, 151000, 541000, 155000];

const getErrorMessage = (method, msg, err) => {
  let errMessage = msg;
  log.e(errMessage);
  if (err.response) {
    const errResponse = err.response;
    log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
    this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
    errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.message}`;
    this.lastError = err.response;
  } else if (err.request) {
    log.e(' -- The request was made, but no response was received from the server', err.request);
    this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
    errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
    this.lastError = err.request;
  } else {
    log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
    this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
    errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
    this.lastError = err.message;
  }
  return errMessage;
};

const defaultDiacriticsRemovalMap = [
  { base: 'A', letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g },
  { base: 'AA', letters: /[\uA732]/g },
  { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g },
  { base: 'AO', letters: /[\uA734]/g },
  { base: 'AU', letters: /[\uA736]/g },
  { base: 'AV', letters: /[\uA738\uA73A]/g },
  { base: 'AY', letters: /[\uA73C]/g },
  { base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
  { base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
  { base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
  { base: 'DZ', letters: /[\u01F1\u01C4]/g },
  { base: 'Dz', letters: /[\u01F2\u01C5]/g },
  { base: 'E', letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g },
  { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
  { base: 'G', letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g },
  { base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
  { base: 'I', letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g },
  { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
  { base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
  { base: 'L', letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g },
  { base: 'LJ', letters: /[\u01C7]/g },
  { base: 'Lj', letters: /[\u01C8]/g },
  { base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
  { base: 'N', letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g },
  { base: 'NJ', letters: /[\u01CA]/g },
  { base: 'Nj', letters: /[\u01CB]/g },
  { base: 'O', letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g },
  { base: 'OI', letters: /[\u01A2]/g },
  { base: 'OO', letters: /[\uA74E]/g },
  { base: 'OU', letters: /[\u0222]/g },
  { base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
  { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
  { base: 'R', letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g },
  { base: 'S', letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g },
  { base: 'T', letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g },
  { base: 'TZ', letters: /[\uA728]/g },
  { base: 'U', letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g },
  { base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
  { base: 'VY', letters: /[\uA760]/g },
  { base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
  { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
  { base: 'Y', letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g },
  { base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
  { base: 'a', letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g },
  { base: 'aa', letters: /[\uA733]/g },
  { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g },
  { base: 'ao', letters: /[\uA735]/g },
  { base: 'au', letters: /[\uA737]/g },
  { base: 'av', letters: /[\uA739\uA73B]/g },
  { base: 'ay', letters: /[\uA73D]/g },
  { base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
  { base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
  { base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
  { base: 'dz', letters: /[\u01F3\u01C6]/g },
  { base: 'e', letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g },
  { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
  { base: 'g', letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g },
  { base: 'h', letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g },
  { base: 'hv', letters: /[\u0195]/g },
  { base: 'i', letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g },
  { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
  { base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
  { base: 'l', letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g },
  { base: 'lj', letters: /[\u01C9]/g },
  { base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
  { base: 'n', letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g },
  { base: 'nj', letters: /[\u01CC]/g },
  { base: 'o', letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g },
  { base: 'oi', letters: /[\u01A3]/g },
  { base: 'ou', letters: /[\u0223]/g },
  { base: 'oo', letters: /[\uA74F]/g },
  { base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
  { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
  { base: 'r', letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g },
  { base: 's', letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g },
  { base: 't', letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g },
  { base: 'tz', letters: /[\uA729]/g },
  { base: 'u', letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g },
  { base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
  { base: 'vy', letters: /[\uA761]/g },
  { base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
  { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
  { base: 'y', letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g },
  { base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g },
];
function removeDiacritics(str) {
  let res = str;
  for (let i = 0; i < defaultDiacriticsRemovalMap.length; i += 1) {
    res = res.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
  }
  return res;
}

function removePunctuation(str) {
  // removed \- minus because it is used in french like in ecole-de-commerce
  // eslint-disable-next-line no-useless-escape
  const punctRE = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,.\/:;<=>?@\[\]^_`{|}~]/g;
  const spaceRE = /\s+/g;
  return str.replace(punctRE, ' ').replace(spaceRE, ' ');
}

const findAddressPosition = (query, callbackLoaded) => {
  const method = 'findAddressPosition';
  log.t(`## IN ${method}`);
  axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
  axios.get(`${DEFAULT_BASE_SERVER_URL}/api/geo/search_position/${query}`)
    .then((resp) => {
      log.t(`## IN ${method} axios get success resp.data :`, resp.data);
      if (functionExist(callbackLoaded)) {
        callbackLoaded(resp.data, 'SUCCESS');
      }
    })
    .catch((err) => {
      const errMessage = getErrorMessage(method,
        `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.get`, err);
      if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
    });
};

function hideVirtualKeyboard() {
  if (
    document.activeElement
    && document.activeElement.blur
    && typeof document.activeElement.blur === 'function'
  ) {
    document.activeElement.blur();
  }
}

// const autoCompleteMsgByDefault = 'Commencez à taper pour rechercher...';
const autoCompleteMsgByDefault = 'Recherche d\'adresse ...';
const convertEnt = (text) => {
  if (isNullOrUndefined(text)) return '';
  let textFiltered = `${text}`.trim();
  textFiltered = textFiltered.replace(/&#39;/g, '\'');
  textFiltered = textFiltered.replace('&amp;', '&');
  textFiltered = (`${textFiltered}`).replace(/&#\d+;/gm, (s) => String.fromCharCode(
    s.match(/\d+/gm)[0],
  ));
  // log.w(`## IN convertEnt : textFiltered : ${textFiltered}`, textFiltered);
  return textFiltered;
};
/*
const coordPfa3180Stfrancois = [538224.21, 152378.17]; // PFA3 180 - St-Francois
const createIconStyleCenterBottom = imagePath => new OlStyle({
  image: new OlStyleIcon({ // http://openlayers.org/en/latest/apidoc/ol.style.Icon.html
    src: imagePath,
    opacity: 0.60,
    anchor: [0.5, 1.0], // we want the marker bottom to be centered
  }),
});
*/
const createIconStyleCenterCenter = (imagePath) => new OlStyle({
  image: new OlStyleIcon({ // http://openlayers.org/en/latest/apidoc/ol.style.Icon.html
    src: imagePath,
    opacity: 1.0,
    anchor: [0.5, 0.5], // we want the marker to be centered
  }),
});

export default {
  name: 'olMap',
  data() {
    return {
      olmap: null,
      ol_Overlay: null, // Overlay to display tooltip
      olGeoLocation: null,
      olGeolocationMapLayer: null,
      gpsTrackingEnabled: false,
      gpsTrackingCounter: 0,
      gpsBlockedByUser: false,
      noGpsErrorMessage: true,
      displayInfo: false,
      layerSwitcherVisible: false,
      overlay: false,
      autoCompleteMsg: autoCompleteMsgByDefault,
      infoList: [
        { title: 'Mes belles informations ...', url: '' },
        { title: 'Des autres informations', url: '' },
      ],
      // queryLayer: null,
      searchResultLayer: null,
      descriptionLimit: 80,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      clearable: false,
      showSearchBox: true,
      mdiLayersOutline,
      mdiClose,
    };
  },
  props: {
    zoom: {
      type: Number,
      default: 8,
    },
    center: {
      type: Array,
      default: () => (coordPfa3180Stfrancois),
    },
    extent: {
      type: Array,
      default: null,
    },
    layersconfig: null,
    objectsGeojsonData: null,
  },
  computed: {
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model)
        .map((key) => ({
          key,
          value: this.model[key] || 'n/a',
        }));
    },
    items() {
      log.l(`in computed items, this.entries.length :${this.entries.length}`);
      return this.entries.map((entry) => {
        const label = entry.label.length > this.descriptionLimit
          ? `${entry.label.slice(0, this.descriptionLimit)}...`
          : entry.label;

        return { ...entry, label };
      });
    },
  },

  watch: {
    search(val, oldval) {
      log.l(`watch-search(val=${val}, oldval= ${oldval})`);
      this.clearable = true; // done here to allow lighthouse 100% success on accessibility
      this.gpsTrackingEnabled = false;
      this.olGeoLocation.setTracking(false);
      if (isNullOrUndefined(val)) return;
      const query = removePunctuation(removeDiacritics(val.trim()));
      if (isNullOrUndefined(query)) return;
      if (query.length < 3) return;
      // on remplace st- par saint-
      const querySearch = query.replace(/st-/, 'saint-');
      // Items have already been loaded
      // if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      findAddressPosition(`${querySearch}`, (retval, errorMsg) => {
        if (errorMsg === 'SUCCESS') {
          log.w('# in search callback for findAddressPosition call retval:', retval);
          this.entries = retval;
        } else {
          log.e(`# ERROR n search callback for findAddressPosition  call
            ERROR : ${errorMsg}
            retval:`, retval);
        }
        this.isLoading = false;
      });
      /*
      fetch(`https://smartmap.lausanne.ch/api/geo/adresses/search_position?ofs=0&query=${val}`)
        .then((res) => res.json())
        .then((res) => {
          log.w('# in search callback for fetch call res:', res);
          // this.entries = res;
        })
        .catch((err) => {
          log.e(`ERROR in watch-search(val=${val})`, err);
        })
        .finally(() => { this.isLoading = false; });
        */
    },
  },
  filters: {
    limitTextSize(text, maxSize = 100) {
      if (isNullOrUndefined(text)) return '';
      if (text.length < maxSize) return text;
      return `${text.substring(0, maxSize)}…`;
    },
    convertEntitiesInText(text) {
      return convertEnt(text);
    },
  },
  mounted() {
    log.t(`mounted() pos:[${this.center[0]}, ${this.center[1]}] zoom: ${this.zoom}`);
    createLausanneMap(
      this.$refs.mymap,
      this.center,
      this.zoom,
      'divLayerSwitcher',
      this.extent,
      false,
      this.layersconfig,
      (pCoordInfo) => {
        log.l('in mounted click callback pCoordInfo :', pCoordInfo);
        // callParentCode(pCoordInfo);
        this.$emit('pointclick', pCoordInfo);
      },
    )
      .then((OMap) => {
        this.olmap = OMap;
        // OVERLAY FOR TOOLTIP
        this.ol_Overlay = new OlOverlay({
          element: this.$refs.tooltip,
          offset: [0, -40],
          positioning: 'top-center',
        });
        this.olmap.addOverlay(this.ol_Overlay);
        this.loadExternalPolygonLayer();
        this.loadSectorsPolygonLayer();
        this.prepareGeolocation(this.gpsTrackingEnabled);

        // pour la recherche par adresse
        this.searchResultLayer = new OlLayerVector({
          source: new OlSourceVector({
            features: [],
          }),
        });
        this.olmap.addLayer(this.searchResultLayer);
        this.searchResultLayer.getSource().clear();

        // on charge la couche des points si elle est presente
        if (!isNullOrUndefined(this.objectsGeojsonData)) {
          log.l('About to call loadGeojsonPointsOfInterest');
          this.loadGeojsonPointsOfInterest(this.objectsGeojsonData);
        }
        /*
          if (!isNullOrUndefined(this.layersconfig.baseLayer)) {
            this.setBaseLayer(this.layersconfig.baseLayer);
          }
          // const egliseStfrancois = new OlFeature(new OlPoint(coordPfa3180Stfrancois));
          // egliseStfrancois.setStyle(createIconStyleCenterCenter('icone_blue.png'));
          this.queryLayer = new OlLayerVector({
            source: new OlSourceVector({
              features: [],
            }),
          });
          this.olmap.addLayer(this.queryLayer);
          this.queryLayer.getSource().clear();
          if (!isNullOrUndefined(this.extent)) {
            this.gotoExtent(this.extent);
          } else {
            this.queryLayer.getSource().clear();
            this.centerMap(this.center, this.zoom);
          }
          const divToc = getEl('divLayerSwitcher');
          LayerSwitcher.renderPanel(this.olmap, divToc);
           */
        // ## EVENTS ##
        this.olmap.on(
          'pointermove',
          (evt) => {
            const features = [];
            const x = Number(evt.coordinate[0])
              .toFixed(2);
            const y = Number(evt.coordinate[1])
              .toFixed(2);
            const info = {
              coordinates: [x, y],
              numFeaturesDetected: 0,
            };
            // const strPosition = `${x},${y}`;
            const lastfeature = this.olmap.forEachFeatureAtPixel(
              evt.pixel,
              (feature, layer) => {
                const localDebug = true;
                let layerName = '';
                if (!isNullOrUndefined(layer)) {
                  layerName = layer.get('name');
                  if (localDebug) {
                    log.l(
                      `feature found in layer : "${layerName}"`,
                    );
                  }
                }
                // on ne veut pas de tooltip pour la couche secteurs
                if (!isNullOrUndefined(layerName)) {
                  if (layerName.indexOf('secteurs') < 0) {
                    const featureProps = feature.getProperties();
                    if (!isNullOrUndefined(featureProps)) {
                      const featureInfo = {
                        id: featureProps.id,
                        feature,
                        layer: layerName,
                        data: featureProps,
                      };
                      // log.l(`Feature id : ${feature_props.id}, info:`, info);
                      features.push(featureInfo);
                    } else {
                      features.push({
                        id: 0,
                        feature,
                        layer: layerName,
                      });
                    }
                  }
                }
                // return feature
              },
            ); // end of forEachFeatureAtPixel
            if (features.length > 0) {
              log.l('GoMap pointermove EVENT ->Array of features found :', features, lastfeature);
              info.numFeaturesDetected = features.length;
              info.features = features;
              let strToolTip = '';
              let layername = '';
              features.forEach((featInfo) => {
                const currentTitle = featInfo.data.title;
                layername += `${featInfo.layer} `;
                if (!isNullOrUndefined(currentTitle)) {
                  strToolTip += `${currentTitle.replace(
                    /(<([^>]+)>)/ig, '',
                  )}<br>`;
                }
              });
              if ((strToolTip.length > 0) && (layername.indexOf('secteurs') < 0)) {
                // log.w(`Before tooltip layer : ${layername}`);
                this.ol_Overlay.setPosition(evt.coordinate);
                this.$refs.tooltip.style.display = '';
                this.$refs.tooltip.innerHTML = strToolTip; // + strPosition;
              } else {
                this.$refs.tooltip.innerHTML = '';
                this.$refs.tooltip.style.display = 'none';
              }
            } else {
              info.numFeaturesDetected = 0;
              info.features = null;
              this.$refs.tooltip.style.display = 'none';
            }
          },
        ); // END OF EVENT HANDLER   this.olmap.on('pointermove'

        const handleClick = (evt) => {
          const x = Number(evt.coordinate[0]).toFixed(2);
          const y = Number(evt.coordinate[1]).toFixed(2);
          log.t(`#in olmap.click at x,y ${x}, ${y}`);
          const info = {
            coordinates: [+x, +y],
            numFeaturesDetected: 0,
          };
          const features = [];
          log.t(`## BEGIN GoMap click callback : ${x},${y}`);

          const lastfeature = this.olmap.forEachFeatureAtPixel(
            evt.pixel,
            (feature, layer) => {
              let layerName = '';
              if (!isNullOrUndefined(layer)) {
                layerName = layer.get('name');
                log.l(`feature found in layer : "${layerName}"`);
                if (layerName === 'limite_externe') {
                  log.w(`WARNING : Point(${x}, ${y} is EXTERNAL to authorized ZONE`);
                  const extent = getBBFromFeature(feature);
                  const featureInfo = {
                    extent,
                    layer: layerName,
                    message: 'WARNING_EXTERNAL_ZONE',
                  };
                  const featureProps = feature.getProperties();
                  if (!isNullOrUndefined(featureProps)) {
                    featureInfo.id = featureProps.id;
                    featureInfo.data = featureProps;
                  }
                  features.push(featureInfo);
                  this.$emit('outsidezone', featureInfo);
                  return;
                }
              }
              const featureProps = feature.getProperties();
              this.$emit('selfeature', feature);
              const extent = getBBFromFeature(feature);
              if (!isNullOrUndefined(featureProps)) {
                const featureInfo = {
                  id: featureProps.id,
                  layer: layerName,
                  // geometryWKT: wkt,
                  extent,
                  data: featureProps,
                };
                log.l(`Feature id : ${featureProps.id}, info:`, info);
                features.push(featureInfo);
              }
            // return feature
            }, { hitTolerance: 15 }, // CGIL PROBLEME CLICK FANTOME
          );
          if (features.length > 0) {
            log.l('->Array of features found :', features);
            info.numFeaturesDetected = features.length;
            info.features = features;
          } else {
            info.numFeaturesDetected = 0;
            info.features = null;
          }
          this.$emit('mapclick', info);
          if (!isNullOrUndefined(lastfeature)) log.l('->Feature found :', lastfeature);
          if (this.layerSwitcherVisible) {
            log.l('#in olmap.click will hide layerswitcher');
            this.layerSwitcherVisible = false;
          // this.olmap.myref2LayerSwitcher.hidePanel();
          }
        };

        this.olmap.on('click', handleClick);
        this.olmap.on('touchstart', handleClick);
        this.olmap.updateSize();
        /*
        window.onresize = () => {
          this.updateSize();
        };
         */
        this.$emit('mapisready');
      }); // End of CreateMap.then()
  }, // end of mounted
  methods: {
    customSearchFilter(item, queryText) { // removed 3rd param itemText === item.label
      // log.t(`item.label : ${item.label},  queryText: ${queryText} itemText:${itemText}`);
      const labelUnaccent = removePunctuation(removeDiacritics(item.label.toLowerCase()));
      const searchText = removePunctuation(removeDiacritics(queryText.toLowerCase()));
      if (searchText.indexOf(' ') > 0) {
        const arrSearchToken = searchText.split(' ');
        // on remplace st- par saint-
        const firstToken = arrSearchToken[0].replace(/st-/, 'saint-');
        return labelUnaccent.indexOf(firstToken) > -1
          || labelUnaccent.indexOf(arrSearchToken[1]) > -1;
      }
      const searchTextFinal = searchText.replace(/st-/, 'saint-');
      return labelUnaccent.indexOf(searchTextFinal) > -1;

      // log.l(`labelUnaccent : ${labelUnaccent},  searchText: ${searchText} indexOf:${pos}`);
    },
    updateSize() {
      const divMap = this.$refs.mymap;
      // const divContainer = this.$refs.screencontainer;
      if (!isNullOrUndefined(divMap)) {
        // divMap.style.height = `${divContainer.clientHeight - TopBarHeight}px`;
        // log.l(`##resize container WxH:${divContainer.clientWidth}x${divContainer.clientHeight}`);
        // log.l(`##resize mymap     WxH: ${divMap.clientWidth} x ${divMap.clientHeight}`);
      }
      this.olmap.updateSize();
    },
    updatePosition(geolocationRef, posFeatureRef, accuracyFeatureRef) {
      const coordinates = geolocationRef.getPosition();
      log.t(`in updatePosition --> ${coordinates[0]}, ${coordinates[1]}`);
      const accuracy = geolocationRef.getAccuracy();
      log.l(`geolocation updatePosition : ${coordinates[0]},${coordinates[1]} accuracy:${accuracy}`);
      const currentPosition = coordinates;
      const currentPointPosition = new OlPoint(currentPosition);
      posFeatureRef.setGeometry(currentPointPosition);
      accuracyFeatureRef.setGeometry(new OlCircleGeom(currentPosition, accuracy));
      this.olmap.getView().setCenter(currentPosition);
      if (this.gpsTrackingCounter < 2) {
        this.olmap.getView().setZoom(8);
        this.gpsTrackingCounter += 1;
      }
    },
    prepareGeolocation(enableGeoLocation) {
      // geolocation stuff so the map follow device pos

      const positionFeature = new OlFeature();
      positionFeature.setStyle(new OlStyle({
        image: new OlCircle({
          radius: 6,
          fill: new OlFill({
            color: '#3399CC',
          }),
          stroke: new OlStroke({
            color: '#fff',
            width: 2,
          }),
        }),
      }));
      const accuracyFeature = new OlFeature();

      const geolocationLayer = new OlLayerVector({
        // map: this.olmap,
        source: new OlSourceVector({
          features: [accuracyFeature, positionFeature],
        }),
      });
      /* to avoid OpenLayers assertion failure you need to comment this addLayer:
        Uncaught AssertionError: Assertion failed.
       See https://openlayers.org/en/v6.12.0/doc/errors/#67 for details.
       */
      this.olmap.addLayer(geolocationLayer);
      this.olGeolocationMapLayer = geolocationLayer;

      const geolocation = new Geolocation({
        // enableHighAccuracy must be set to true to have the heading value.
        trackingOptions: {
          enableHighAccuracy: true,
        },
        projection: this.olmap.getView()
          .getProjection(),
      });
      this.olGeoLocation = geolocation;
      geolocation.setTracking(enableGeoLocation);


      // update the HTML page when the geolocation information changes.
      geolocation.on('change', () => {
        log.t(`geolocation.on('change' Accuracy: ${geolocation.getAccuracy()}`);
        this.updatePosition(geolocation, positionFeature, accuracyFeature);
        // geolocationChangeCallback(geolocation);
      });

      geolocation.on('error', (error) => {
        log.e(`geolocation ERROR : ${error.message}`);
        this.gpsBlockedByUser = true;
      });

      geolocation.on('change:accuracyGeometry', () => {
        log.t(`geolocation.on('change:accuracyGeometry' Accuracy: ${geolocation.getAccuracy()}`);
        this.updatePosition(geolocation, positionFeature, accuracyFeature);
      });

      geolocation.on('change:position', () => {
        log.t(`geolocation.on('change:position' Accuracy: ${geolocation.getAccuracy()}`);
        this.updatePosition(geolocation, positionFeature, accuracyFeature);
      });
    },
    gotoNewPos(arrCoordPos, zoomLevel = 9) {
      if (!isNullOrUndefined(arrCoordPos)) {
        log.t(`# gotoNewPos x,y = (${arrCoordPos[0]},${arrCoordPos[1]}) zoom = ${zoomLevel}`);
        const newPos = [
          Number.parseFloat(arrCoordPos[0]),
          Number.parseFloat(arrCoordPos[1])];
        this.centerMap(newPos, zoomLevel);
      }
    },
    centerMap(arrCoordPos, zoomLevel = 9) {
      if (!isNullOrUndefined(arrCoordPos)) {
        log.t(`centerMap x,y = (${arrCoordPos[0]},${arrCoordPos[1]}) zoom = ${zoomLevel}`);
        this.olmap.getView().setCenter(arrCoordPos);
        this.olmap.getView().setZoom(zoomLevel);
      }
    },
    gotoSelectedAdr(objSelected) {
      log.t('# gotoSelectedAdr', objSelected);
      if (!isNullOrUndefined(objSelected)) {
        // this.arrSelectionsAdresse.push(objSelected)
        if (!isNullOrUndefined(objSelected.id)) {
          const arrCoords = objSelected.id.split('_');
          const newPos = [
            Number.parseFloat(arrCoords[0]),
            Number.parseFloat(arrCoords[1]),
          ];
          this.centerMap(newPos, 8);
          this.searchResultLayer.getSource().clear(); // pour effacer ancienne recherche
          const newPlace = new OlFeature(new OlPoint(newPos));
          newPlace.setStyle(createIconStyleCenterCenter('search_result.png'));
          this.searchResultLayer.getSource().addFeature(newPlace);
          hideVirtualKeyboard();
          // pour essayer de fermer le clavier virtuel
          this.$refs.mymap.focus();
        }
      }
    },
    gotoExtent(arrExtent = EXTENT) {
      log.t('In gotoExtent ');
      const localDebug = false;
      if (localDebug) log.t('# gotoExtent', arrExtent);
      if (!isNullOrUndefined(arrExtent)) {
        if (localDebug) {
          log.t(`# gotoExtent MIN(x,y) = (${arrExtent[0]},${arrExtent[1]})
        Max(x,y) = (${arrExtent[2]},${arrExtent[3]})`);
        }
        // just in case ...
        const extent = [
          Number.parseInt(arrExtent[0], 10),
          Number.parseInt(arrExtent[1], 10),
          Number.parseInt(arrExtent[2], 10),
          Number.parseInt(arrExtent[3], 10),
        ];
        if (localDebug) log.t('# gotoExtent', extent);
        this.olmap.getView()
          .fit(extent, this.olmap.getSize());
      }
    },
    toggleGpsTracking() {
      log.t(`# toggleGpsTracking this.gpsTrackingEnabled : ${this.gpsTrackingEnabled}`);
      if (this.gpsTrackingEnabled) {
        this.gpsTrackingEnabled = false;
        this.gpsTrackingCounter = 0;
        this.olGeoLocation.setTracking(false);
        this.autoCompleteMsg = autoCompleteMsgByDefault;
        this.olGeolocationMapLayer.setVisible(false);
      } else {
        this.search = null;
        this.gpsTrackingEnabled = true;
        this.olGeoLocation.setTracking(true);
        this.autoCompleteMsg = autoCompleteMsgByDefault;
        if (!isNullOrUndefined(this.olGeolocationMapLayer)) {
          this.olGeolocationMapLayer.setVisible(true);
        }
      }
    },
    toggleLayerSwitcher() {
      log.t(`# toggleLayerSwitcher this.layerSwitcherVisible : ${this.layerSwitcherVisible}`);
      if (this.layerSwitcherVisible) {
        // this.layerSwitcherVisible = false;
        // this.olmap.myref2LayerSwitcher.hidePanel();
      } else {
        this.layerSwitcherVisible = true;
        // this.olmap.myref2LayerSwitcher.showPanel();
      }
    },
    clearItems() {
      log.t('clear');
      this.search = null;
      this.entries = [];
    },
    getVisibleLayers() {
      log.t('getVisibleLayers');
      this.olmap.getLayers().forEach((layer) => {
        const type = isNullOrUndefined(layer.get('type')) ? layer.type : layer.get('type');
        const source = layer.getSource();
        if (functionExist(source.getParams)) {
          const sourceParams = source.getParams();
          const sourceLayers = isNullOrUndefined(sourceParams) ? 'NULL' : sourceParams.LAYERS;
          log.l(`layers : ${sourceLayers} [${type}]
        title : ${layer.get('title')}
        isvisible: ${layer.get('visible')}`, layer, source);
        } else {
          log.l(`title : ${layer.get('title')} [${type}]
                  isvisible: ${layer.get('visible')}`, layer, source);
        }
      });
    },
    setBaseLayer(baseLayerName) {
      log.t(`setBaseLayer(${baseLayerName})`);
      let isBaseLayerNameFound = false;
      this.olmap.getLayers().forEach((layer) => {
        const type = isNullOrUndefined(layer.get('type')) ? layer.type : layer.get('type');
        const source = layer.getSource();
        if (type === 'base') {
          const currentBaseLayer = source.getLayer();
          if (currentBaseLayer === baseLayerName) {
            layer.setVisible(true);
            isBaseLayerNameFound = true;
          } else {
            layer.setVisible(false);
          }
          log.l(`layers : ${currentBaseLayer} [${type}]
                 title : ${layer.get('title')}
                 isvisible: ${layer.get('visible')}`, layer, source);
        }
      });
      if (!isBaseLayerNameFound) {
        log.w(`WARNING : The layer ${baseLayerName} was not found ! SETTING fonds_geo_osm_bdcad_couleur TO VISIBLE `);
        this.setBaseLayer('fonds_geo_osm_bdcad_couleur');
      }
      const divToc = getEl('divLayerSwitcher');
      LayerSwitcher.renderPanel(this.olmap, divToc);
    },
    loadExternalPolygonLayer() {
      log.t('In loadExternalPolygonLayer ');
      const olMap = this.olmap;
      const layerName = 'limite_externe';
      const olLayer = getLayerByName(olMap, layerName);
      let numFeatures = 0;
      if (isNullOrUndefined(olLayer)) {
        // layer was not yet created so just do it
        log.t(`In loadExternalPolygonLayer creating ${layerName}`);
        const vectorSource = getVectorSourceGeoJson(externalPolygon, true);
        const newVectorLayer = new OlLayerVector({
          title: layerName,
          name: layerName,
          source: vectorSource,
          style: getPolygonStyle,
        });
        olMap.addLayer(newVectorLayer);
        // no need to zoom on the external polygon
        // const extent = newVectorLayer.getSource().getExtent();
        // olMap.getView().fit(extent, olMap.getSize());
        numFeatures = getNumberFeaturesInLayer(newVectorLayer);
      }
      log.l(`End of loadExternalPolygonLayer now ${layerName} has ${numFeatures} features`);
    },
    loadSectorsPolygonLayer() {
      log.t('In loadSectorsPolygonLayer ');
      const olMap = this.olmap;
      const layerName = 'secteurs';
      const olLayer = getLayerByName(olMap, layerName);
      let numFeatures = 0;
      if (isNullOrUndefined(olLayer)) {
        // layer was not yet created so just do it
        log.t(`In loadSectorsPolygonLayer creating ${layerName}`);
        const vectorSource = getVectorSourceGeoJson(sectors, true);
        const newVectorLayer = new OlLayerVector({
          title: layerName,
          visible: true,
          name: layerName,
          source: vectorSource,
          style: getPolygonStyle,
        });
        olMap.addLayer(newVectorLayer);
        const extent = newVectorLayer.getSource().getExtent();
        olMap.getView().fit(extent, olMap.getSize());
        numFeatures = getNumberFeaturesInLayer(newVectorLayer);
      }
      log.l(`End of loadSectorsPolygonLayer now ${layerName} has ${numFeatures} features`);
    },
    getPointStyle(feature, resolution,
      options = {
        icon_src: '/img/gomarker_star_blue.png',
      }) {
      const localDebug = false;
      if (localDebug) {
        log.t('## Entering getPointStyle with feature :', feature);
        log.l(`resolution : ${resolution}`);
      }

      let props = null;
      let theStyle = null;
      if (!isNullOrUndefined(feature) && !isNullOrUndefined(feature.getProperties())) {
        props = feature.getProperties();
        const id = isNullOrUndefined(props.id) ? '#INCONNU#' : props.id;
        let iconSrc = options.icon_src;
        if (!isNullOrUndefined(props.icon_src)) {
          if (!isNullOrUndefined(props.isvalidated)) {
            iconSrc = props.isvalidated ? `/img/${props.icon_src}_valide.png` : `/img/${props.icon_src}_attente.png`;
          } else {
            iconSrc = `/img/${props.icon_src}_attente.png`;
          }
        }
        if (localDebug) log.l(`id : ${id} title: ${props.title}, icon_src:${iconSrc} `);
        theStyle = new Style({
          image: new Icon(({
            anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: iconSrc,
          })),
        });
      } else {
        theStyle = new Style({
          image: new Icon(({
            anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: options.icon_src,
          })),
        });
      }
      return theStyle;
    },
    loadGeojsonPointsOfInterest(newGeoJsonData) {
      log.w('### entering loadGeojsonPointsOfInterest:', newGeoJsonData);
      let numFeatures = 0;
      const olMap = this.olmap;
      const layerName = geoJsonLayerName;
      const tempSource = new OlSourceVector(
        {
          format: new OlFormatGeoJSON(
            {
              defaultDataProjection: 'EPSG:2056',
              projection: 'EPSG:2056',
            },
          ),
          features: (new OlFormatGeoJSON()).readFeatures(newGeoJsonData),
        },
      );
      const olLayer = getLayerByName(olMap, layerName);
      log.l('# in loadGeojsonPointsOfInterest after getLayerByName olLayer:', olLayer);
      if (isNullOrUndefined(olLayer)) {
        // layer was not yet created so just do it
        log.t(`In loadGeojsonPointsOfInterest creating ${layerName}`);
        const vectorLayer = new OlLayerVector(
          {
            title: layerName,
            name: layerName,
            source: tempSource,
            style: this.getPointStyle,
          },
        );
        // vectorLayer.setMap(olMap); // overlay ?
        olMap.addLayer(vectorLayer);
        numFeatures = getNumberFeaturesInLayer(vectorLayer);
      } else {
        log.t(`In loadGeojsonPointsOfInterest updating feature to existing ${layerName}`);
        const vectorSource = olLayer.getSource();
        vectorSource.clear(); // on efface ancien
        olLayer.setSource(tempSource);
        // vectorSource.addFeatures((new OlFormatGeoJSON()).readFeatures(newGeoJsonData));
        // vectorSource.refresh({ force: true });
        numFeatures = getNumberFeaturesInLayer(olLayer);
      }
      log.l(`End of loadGeojsonPointsOfInterest now ${layerName} has ${numFeatures} features`);
    },
    addNewMarker(markerPos, markerTitle) {
      log.t('In addNewMarker markerPos:', markerPos);
      const olMap = this.olmap;
      const layerName = geoJsonMarkersLayerName;
      const olLayer = getLayerByName(olMap, layerName);
      let numFeatures = 0;
      const iconFeature = new OlFeature({
        geometry: new OlPoint(markerPos),
        title: markerTitle,
        id: 0,
      });
      const iconStyle = new Style({
        image: new Icon(({
          anchor: [0.5, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: '/img/gomarker_star.png',
        })),
      });
      iconFeature.setStyle(iconStyle);
      if (isNullOrUndefined(olLayer)) {
        // layer was not yet created so just do it
        log.t(`In addNewMarker creating ${layerName}`);
        const vectorSource = new OlSourceVector({ features: [iconFeature] });
        const vectorLayer = new OlLayerVector({
          title: layerName,
          name: layerName,
          source: vectorSource,
        });
        // vectorLayer.setMap(olMap); // overlay ?
        olMap.addLayer(vectorLayer);
        numFeatures = getNumberFeaturesInLayer(vectorLayer);
      } else {
        log.t(`In addNewMarker adding feature to existing ${layerName}`);
        const vectorSource = olLayer.getSource();
        vectorSource.clear(); // on efface ancien marker
        vectorSource.addFeature(iconFeature);
        numFeatures = getNumberFeaturesInLayer(olLayer);
      }
      log.l(`End of addNewMarker now ${layerName} has ${numFeatures} features`);
      return iconFeature;
    },
    clearNewMarker() {
      log.t('In clearNewMarker');
      const olMap = this.olmap;
      const layerName = geoJsonMarkersLayerName;
      const olLayer = getLayerByName(olMap, layerName);
      if (isNullOrUndefined(olLayer)) {
        // layer was not yet created so nothing to clear
        log.t(`In clearNewMarker ${layerName} does not exist so no features to clear !`);
      } else {
        log.t(`In clearNewMarker clearing features in ${layerName}`);
        const vectorSource = olLayer.getSource();
        vectorSource.clear(); // on efface ancien marker
      }
    },
  },

};

</script>
